import { Component, Inject, OnInit } from '@angular/core';import { UmsService } from '../ums.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-holiday-dates-dialog',
  templateUrl: './holiday-dates-dialog.component.html',
  styleUrls: ['./holiday-dates-dialog.component.scss']
})
export class HolidayDatesDialogComponent implements OnInit {
  HolidayDatesForm: FormGroup;
  sessionList: any;
  SessionFilterList: any;
  submitpayload: any;
  arr: [];
  holidayList: any;
  DateArray: FormArray;
  dialogRef: MatDialogRef<any>;
  submitButton = true;
  editButton = false;
  APIService: string;
  errMsg: any;
  Table = false;
  // currentdate;
  currentdate: any;
  selectedDate: Date;
  date: string;
  isdisabled = false;
  constructor( public umsService: UmsService,private spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef2: MatDialogRef<HolidayDatesDialogComponent>,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,
    private httpClient: HttpClient,
    public datepipe: DatePipe,
  ) { this.APIService = environment.serviceUrl}
  todayDate: Date = new Date();
  ngOnInit(): void {
    this.Table = false;
    this.currentdate = new Date();
    // this.currentdate = new Date().setHours(0, 0, 0, 0);
    this.date = this.datepipe.transform(this.currentdate, 'yyyy-MM-dd');
    this.HolidayDatesForm = this.fb.group({
      SnNo: new FormControl(''),
      FromDate: new FormControl(''),
      ToDate: new FormControl(''),
      HolidayName: new FormControl(''),
      DateArray: new FormArray([]),
    });
    if (this.data.key == "Edit") {
      this.prepopulateRecord(this.data.selected);
    } 
    else if (this.data.key == "New") {
      this.addNewRow();
    }
    let id = ''
    this.fetchSession(id);
    this.getHolidayData();
  }
  fetchSession(id) {
    this.Table = true; 
    const payload = {};
    payload['SnDefault'] = id;
    payload['SnNo'] = id;
    this.umsService.getSession(payload).subscribe(res => {
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    })
  }
  submitFun1() {
    this.DateArray = this.HolidayDatesForm.get('DateArray') as FormArray;
    if (this.HolidayDatesForm.invalid) {
      this.HolidayDatesForm.get('SnNo').markAsTouched();
      let x = (this.HolidayDatesForm.get('DateArray') as FormArray).controls;
      x.forEach(element => {
        element['controls']['ToDate'].markAsTouched();
        element['controls']['FromDate'].markAsTouched();
        element['controls']['HolidayName'].markAsTouched();
      });
      
    }
    else {
      this.delete();
    }
  }
  submit() {
    this.spinner.show();
    let payload = {}
    payload = this.HolidayDatesForm.value;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      payload['DateArray'].forEach((element, index, array) => {
        let arr1 = [];
        arr1.push(
          this.fb.group({
            SnNo: new FormControl(payload['SnNo']),
            ToDate: new FormControl(this.datepipe.transform(element['ToDate'], 'yyyy-MM-dd')),
            FromDate: new FormControl(this.datepipe.transform(element['FromDate'], 'yyyy-MM-dd')),
            HolidayName: new FormControl(element['HolidayName'],[Validators.required, Validators.pattern('^[a-zA-Z- ]*$')]),
          })
        )
        this.umsService.SubmitHoliday(arr1[0].value).subscribe(res => {
          this.spinner.hide();
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message
          }
          if (index === array.length - 1) resolve();
          else {
            iserror = false
            this.errMsg = res.message
            // this.NewCoSch();  disabled automatic course schedule api calls as discussed on 21/02/24
          }
          if (res.status == true) {
            iserror = false
            this.errMsg = res.message
            // this.NewCoSch();  disabled automatic course schedule api calls as discussed on 21/02/24
          }
        }, (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          iserror = true;
          this.errMsg = ERROR.error.message
          if (index === array.length - 1) resolve();
        });

      });
    })
    bar.then(() => {
      if (iserror == false) {
        let data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.dialogRef2.close()
        });
      } else {
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
      }
    });
  }
  // submit() {
  //   this.spinner.show();
  //   this.submitpayload = this.HolidayDatesForm.value;
  //   let payload = {};
  //   this.submitpayload.DateArray[0].FromDate = this.datepipe.transform(this.submitpayload.DateArray[0].FromDate, 'yyyy-MM-dd');
  //   this.submitpayload.DateArray[0].ToDate = this.datepipe.transform(this.submitpayload.DateArray[0].ToDate, 'yyyy-MM-dd');
  //   payload['SnNo'] = this.submitpayload['SnNo'];
  //   payload['ToDate'] =this.submitpayload.DateArray[0].ToDate;
  //   payload['FromDate'] =this.submitpayload.DateArray[0].FromDate;
  //   payload['HolidayName'] =this.submitpayload.DateArray[0].HolidayName;
  //   this.umsService.SubmitHoliday(payload).subscribe(res => {
  //     this.spinner.hide();
  //     if (res.status) {
  //       let data = {}
  //       data['message'] = res.message
  //       data['title'] = 'Information'
  //       data['icon'] = 'fas fa-check'
  //       this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //       this.dialogRef.afterClosed().subscribe(result => {
  //       });
  //     } else {
  //       this.spinner.hide();
  //       let data = {}
  //       data['message'] = res.message
  //       data['title'] = 'Information'
  //       data['icon'] = 'fas fa-close'
  //       this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //       this.dialogRef.afterClosed().subscribe(result => {
  //       });
  //     }
  //   }, (ERROR: HttpErrorResponse) => {
  //     let data = {}
  //     data['message'] = ERROR.error.message
  //     data['title'] = 'Information'
  //     data['icon'] = 'fas fa-check'
  //     this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //     this.spinner.hide();

  //   });
  // }
  delete() {
    this.spinner.show();
    let payload = {}
    payload = this.HolidayDatesForm.value;
    payload['DateArray'][0]['FromDate'] = this.datepipe.transform(payload['DateArray'][0]['FromDate'], 'yyyy-MM-dd');
    payload['DateArray'][0]['ToDate'] = this.datepipe.transform(payload['DateArray'][0]['ToDate'], 'yyyy-MM-dd');
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
        SnNo: payload['SnNo'],
        ToDate: payload['DateArray'][0]['ToDate'],
        FromDate: payload['DateArray'][0]['FromDate'],
        HolidayName: payload['DateArray'][0]['HolidayName'],
      },
    };
    this.spinner.hide();
    this.httpClient.delete(this.APIService + '/supervisor/InsertHolidayDate', options)
      .subscribe((s) => {
        let cc = [];
        cc.push(s);
        this.submit();
      }, (ERROR: HttpErrorResponse) => {
 
      });
  }
  getHolidayData() {
    this.spinner.show();
    const payload = {};
    payload['SnNo'] = 1;
    this.umsService.getExamHoliday(payload).subscribe(res => {
      this.holidayList = res.data;
      this.spinner.hide();
    }, (ERROR: HttpErrorResponse) => {
      this.holidayList = [];
      let data = {}
      this.spinner.hide();
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }
  prepopulatedData(e) {
    this.DateArray = this.HolidayDatesForm.get('DateArray') as FormArray;
    this.DateArray.clear();
    let payload = {}
    payload['SnNo'] = e.SnNo;
    this.umsService.getExamHoliday(payload).subscribe(res => {
      if (res.status) {
        this.editButton = true;
        this.submitButton = false;
        this.DateArray = this.HolidayDatesForm.get('DateArray') as FormArray;
        this.DateArray.clear();
        this.Table = true;
        res.data.forEach(element => {
          // this.prepopulateNew(element);
          const creds = this.HolidayDatesForm.controls.DateArray as FormArray;
          creds.push(
            this.fb.group({
              FromDate: new FormControl(this.datepipe.transform(element.FromDate, 'yyyy-MM-dd'), [Validators.required]),
              ToDate: new FormControl(this.datepipe.transform(element.ToDate, 'yyyy-MM-dd'), [Validators.required]),
              HolidayName: new FormControl(element.HolidayName, [Validators.required, Validators.pattern('^[a-zA-Z- ]*$')]),
            })
          );
        });
      }
      
      else {
        this.editButton = false;
        this.submitButton = true;
        this.DateArray = this.HolidayDatesForm.get('DateArray') as FormArray;
        this.DateArray.clear();
        this.addNewRow();
        this.Table = true;
      }

    })
  }
  prepopulateRecord(e) {
    this.spinner.show();
    this.editButton = true;
    this.submitButton = false;
    this.isdisabled = true;
    const payload = {};
    this.fetchSession('');
    payload['SnNo'] = e.SnNo;
    // payload['ToDate'] = e.ToDate;
    // payload['FromDate'] = e.FromDate;
    // payload['HolidayName'] = e.HolidayName
    this.umsService.getExamHoliday(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.Table = true
        this.HolidayDatesForm.patchValue({
          SnNo: res.data[0]['SnNo'],

        });
        res.data.forEach(element => {
          this.prepopulateNew(element);
        });
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });
  }
  prepopulateNew(e) {
    this.Table = true
    const creds = this.HolidayDatesForm.controls.DateArray as FormArray;
    creds.push(
      this.fb.group({
        FromDate: new FormControl(this.datepipe.transform(e.FromDate, 'yyyy-MM-dd'), [Validators.required]),
        ToDate: new FormControl(this.datepipe.transform(e.ToDate, 'yyyy-MM-dd'), [Validators.required]),
        HolidayName: new FormControl(e.HolidayName, [Validators.required, Validators.pattern('^[a-zA-Z- ]*$')]),
      })
    );
  }
  getControls() {
    return (this.HolidayDatesForm.get('DateArray') as FormArray).controls;
  }
  addNewRow() {
    const creds = this.HolidayDatesForm.controls.DateArray as FormArray;
    creds.push(
      this.fb.group({
      FromDate: new FormControl('',Validators.required),
      ToDate: new FormControl('',Validators.required),
      HolidayName: new FormControl('',[Validators.required, Validators.pattern('^[a-zA-Z- ]*$')]),
      })
    );
 
  }
  addNewRow2(i, e) {
    this.arr = this.HolidayDatesForm.controls.DateArray.value
    this.DateArray = this.HolidayDatesForm.get('DateArray') as FormArray;
    if (this.DateArray.invalid) {
      this.DateArray.controls.forEach(element => {
        element.get('FromDate').markAsTouched();
        element.get('ToDate').markAsTouched();
        element.get('HolidayName').markAsTouched();
 
      })
    }
    else {
      this.arr = this.HolidayDatesForm.controls.DateArray.value
      const creds = this.HolidayDatesForm.controls.DateArray as FormArray;
      creds.push(
        this.fb.group({
          FromDate: new FormControl('',Validators.required),
          ToDate: new FormControl('',Validators.required),
      HolidayName: new FormControl('',[Validators.required, Validators.pattern('^[a-zA-Z- ]*$')]),
        })
      );
      // this.addNewRow();
    }
 
  }
  deleteRow(index){
    if(index !== 0){
      (<FormArray>this.HolidayDatesForm.get("DateArray")).removeAt(index);
      this.arr = this.HolidayDatesForm.controls.DateArray.value
      this.DateArray = this.HolidayDatesForm.controls.DateArray.value.length
      const data = this.HolidayDatesForm.controls.DateArray.value
      data.forEach((element,i) => {
        this.DateArray = this.HolidayDatesForm.get('DateArray') as FormArray;
      });
      this.arr = this.HolidayDatesForm.controls.DateArray.value
    }
    else{
      let  data = {}
      data['message'] = "First Row Can Not Be Deleted"
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
   
    }
   
  }

  datechange(i) {
    let taskListArrays = this.HolidayDatesForm.get('DateArray') as FormArray;
    let fromDateControl = taskListArrays.controls[i].get('FromDate');
    let toDateControl = taskListArrays.controls[i].get('ToDate');
    let FromDate = new Date(fromDateControl.value);
    let ToDate = new Date(toDateControl.value);

    let formattedDated = this.datepipe.transform(taskListArrays.controls[i].value['FromDate'], 'yyyy-MM-dd');
    if (this.isDatePassed(taskListArrays.controls[i].value['FromDate']) || formattedDated < this.currentdate) {
      let data = {
        message: "Date Cannot Be Less Than Today's Date",
        title: 'Information',
        icon: 'fas fa-close'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
      fromDateControl.setValue('');
      fromDateControl.setErrors({ TodaydateError: true });
    } else {
      fromDateControl.setErrors(null);
    }
    if (toDateControl.value) {
      if (FromDate > ToDate) {
        let data = {
          message: "From Date Cannot Be Greater Than To Date",
          title: 'Information',
          icon: 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
        fromDateControl.setValue('');
        fromDateControl.setErrors({ dateError: true });
      } else {
        fromDateControl.setErrors(null);
      }
    }
  }
  

  datechange1(i) {
    let taskListArrays = this.HolidayDatesForm.get('DateArray') as FormArray;
    let fromDateControl = taskListArrays.controls[i].get('FromDate');
    let toDateControl = taskListArrays.controls[i].get('ToDate');
    let FromDate = new Date(fromDateControl.value);
    let ToDate = new Date(toDateControl.value);
  
    // Check if ToDate is less than the current date
    // let formattedDated = this.datepipe.transform(taskListArrays.controls[i].value['ToDate'], 'yyyy-MM-dd');
    // if (this.isDatePassed(taskListArrays.controls[i].value['ToDate']) || formattedDated < this.currentdate) {
    //   let data = {
    //     message: "Date Cannot Be Less Than Today's Date",
    //     title: 'Information',
    //     icon: 'fas fa-close'
    //   };
    //   this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
    //     AlertBoxComponent,
    //     data
    //   );
    //   toDateControl.setValue('');
    //   toDateControl.setErrors({ TodaydateError: true });
    // } else {
    //   toDateControl.setErrors(null);
    // }
  
    // Check if ToDate is less than FromDate
    if (FromDate && ToDate) {
      if (ToDate < FromDate) {
        let data = {
          message: "To Date Cannot Be Less Than From Date",
          title: 'Information',
          icon: 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
        toDateControl.setValue('');
        toDateControl.setErrors({ dateError: true });
      } else {
        toDateControl.setErrors(null);
      }
    }
  }

  isDatePassed(ToDate: Date): boolean {
    const todayDate = new Date();
    const cutOff = new Date(ToDate); 
    todayDate.setHours(0, 0, 0, 0);
    cutOff.setHours(0, 0, 0, 0);
    return cutOff < todayDate;
  }
  selectSessionID(id) {
    this.prepopulatedData(this.HolidayDatesForm.value)
  }
}

